import type { GuideSlice } from '../bs/guide'

/**
 * Croatian overrides for the guide screen.
 *
 * One word does the work here: *upute* rather than *uputstvo*, which is the
 * distinction this locale is most often judged on, and it appears in the label
 * of every control on the page. Both standards are ijekavica, so nothing moves
 * for the jat reflex and the rest is inherited.
 */
export const guide: Partial<GuideSlice> = {
  'guide.download': 'Preuzmi upute (PDF)',
  'guide.preview.label': 'Prikaži upute za ulogu',
  'guide.preview.note':
    'Ovo su upute koje vidi kolega s ulogom {role}. Vaša se uloga time ne mijenja — ovo je samo pregled.',
}
